// @ts-check
/**
 *
 * @param {unknown} val The given size value.
 * @returns {string} A properly formatted size value.
 */
export function addPx(val) {
	if (typeof val === 'number') {
		// A valid number just needs px.
		return val + 'px';
	} else if (typeof val === 'string') {
		// Already perfectly formatted we think.
		return val;
	}

	return '';
}
